module.exports = __webpack_public_path__ + "img/2074.5b07fcdf.gif";